export function configurePopularSearch() {
    const showPanel = document.querySelector('#show-links');
    const showPanelMobile = document.querySelector('#show-links-mobile');
    const hidePanel = document.querySelector('#hide-links');
    const hidePanelMobile = document.querySelector('#hide-links-mobile');
    const panel = document.querySelector('#popular-searches');

    function revealSearchPanel() {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        panel.classList.remove('max-h-0');
        panel.removeAttribute('inert');
        panel.setAttribute('aria-hidden', 'false');

        showPanel.style.display = 'none';
        showPanelMobile.style.display = 'none';
        hidePanel.style.display = 'block';
        hidePanelMobile.style.display = 'block';
        setTimeout(function() {
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        }, 85);
    }

    function hideSearchPanel() {
        panel.style.maxHeight = null;
        panel.classList.add('max-h-0');
        panel.setAttribute('inert', '');
        panel.setAttribute('aria-hidden', 'true');

        hidePanel.style.display = 'none';
        hidePanelMobile.style.display = 'none';
        showPanel.style.display = 'block';
        showPanelMobile.style.display = 'block';
    }

    showPanel.addEventListener('click', function(e) {
        e.preventDefault();
        revealSearchPanel();
    });

    hidePanel.addEventListener('click', function(e) {
        e.preventDefault();
        hideSearchPanel();
    });

    showPanelMobile.addEventListener('click', function(e) {
        e.preventDefault();
        revealSearchPanel();
    });

    hidePanelMobile.addEventListener('click', function(e) {
        e.preventDefault();
        hideSearchPanel();
    });
};

// Load the function when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    configurePopularSearch();
});
